module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-right-1.0ed6ca6e.png";